import NavigationMenu from '@/@@layouts/Default/NavigationMenu/NavigationMenu.vue';

export default NavigationMenu;
